// extracted by mini-css-extract-plugin
export default {"button":"SubmitButton_button__M4Oex"};